import { render, staticRenderFns } from "./store-performance.vue?vue&type=template&id=7dd5ebf4&scoped=true&"
import script from "./store-performance.vue?vue&type=script&lang=js&"
export * from "./store-performance.vue?vue&type=script&lang=js&"
import style0 from "./store-performance.vue?vue&type=style&index=0&id=7dd5ebf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd5ebf4",
  null
  
)

export default component.exports